<template>
	<div class="introduce">
		<div class="introduce-top"></div>
		<div class="describe">
			<div>
				<span class="mark">大赛目的</span>
				<div class="details">
					{{form.Purpose}}
				</div>
			</div>
			<div>
				<span class="mark">主办单位</span>
				<div class="details">
					{{form.Organizers}}
				</div>
			</div>
			<div class="button-box">
				<button class="personalbtn" @click="registrants()">个人报名</button>
				<button class="teambtn" @click="Shutdown()">团队报名</button>
			</div>
		</div>
		<div class="introduce-review">
			<h1>评审团介绍</h1>
			<div class="review-box">
				<div class="judges" v-for="item of JuryArr" :key='item.Name'>
					<div class="imgbox">
						<img v-if="item.FullPhoto" :src="item.FullPhoto" alt="">
					</div>
					<p class="name">{{item.Name}}</p>
					<p class="title">{{item.Descrip}}</p>
				</div>

			</div>
		</div>

		<div class="unitbox">
			<div class="unitbox-inner">
				<div v-for="item of units" :key='item.name'>
					<span class="unit_title">{{item.name}}</span>
					<div class="units">
						<span v-for='items of item.units'>{{items}}</span>
					</div>
				</div>
			</div>

		</div>
		<teamSign v-on:downfun='downfun' v-if='down'></teamSign>
		<IndividualEditor  v-on:Indguanbi='Indguanbi' v-if='isshow'></IndividualEditor>
		<v-login v-on:guanbi='guanbi' v-on:bindSuccess='bindSuccess' v-if="login"></v-login>
	</div>
</template>

<script>
	import IndividualEditor from '@/components/common/IndividualEditor'
	import teamSign from '@/components/common/teamSign'
	import vLogin from '@/components/common/login'
	export default {
		data() {
			return {
				isshow:0,
				login:0,
				down:0,
				UserInfo:Object,
				current: 1,
        form:Object,
				JuryArr:[],
				units:[
					{
						name:'主办单位',
						units:['北京市金融工会','北京市地方金融监督管理局','北京市银保监局']
					},
					{
						name:'承办单位',
						units:['北京市理财规划师协会']
					},{
						name:'协办单位',
						units:['北京市银行业协会','北京证券业协会','北京保险行业协会','北京期货商会协办','首都金融服务商会']
					},
					{
						name:'技术支持',
						units:['北京华尔金服网络科技有限公司']
					}
				],
			};
		},
		created(){
			this.getmember()
			this.getJury()
      this.GetSiteSetting()
		},
		methods:{
      GetSiteSetting() {
      	this.axios.get('/api/SiteSetting/GetSiteSetting')
      	.then(response => {
          console.log(response)
          this.form = response.data.data
      	}).catch(error => {
      		console.log(error)
      	})
      },
			getJury() {
				this.loading = true
				this.axios.get('/api/Jury/GetHomeList')
					.then(response => {

						console.log(response.data.data)
						this.JuryArr = response.data.data
					}).catch(error => {
						console.log(error)
					})
			},
			guanbi:function(guanbi){
				this.login = guanbi
			},
			Indguanbi:function(Indguanbi){
				this.isshow  = Indguanbi
				this.getmember()
			},
			bindSuccess:function(guanbi){
				this.login = guanbi
			},
			downfun:function(down){
				this.down = down
			},
			getmember(){
				this.axios.get('/api/member/GetMember')
				.then(res => {
						this.UserInfo = res.data.data
				})
				.catch(error => {
				  console.log(error)
				})
			},
			registrants(){
				var competition_info = JSON.parse(localStorage.getItem('competition_info'))
				if(competition_info){
					console.log(this.UserInfo.UserName)
					if(this.UserInfo.UserName){
						if(competition_info.RegistType == 1||competition_info.RegistType == 2){
							this.$confirm('你已报名，请前往个人中心进行线上学习或答题！', '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {
								this.$router.push('/myteam')
							})
						}else{
							this.$confirm('个人参赛将不能参加团队比赛，请确认是否报名！', '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {
								console.log(111)
								this.axios.post('/api/CompetitionRegist/PesonRegist')
								.then(res => {
										if(res.data.Success){
											this.$message({
											  message: '报名成功，请前往个人中心进行线上学习或答题！',
											  type: 'success'
											});
											this.RegistType = 2
											var competition_info = JSON.parse(localStorage.getItem('competition_info'))
											competition_info.RegistType = 2
											localStorage.setItem("competition_info",JSON.stringify(competition_info))
										}else{
											this.$message({
											  message: res.data.ErrorMsg,
											  type: 'error'
											});
										}
								})
								.catch(error => {
								  console.log(error)
								})
							})

						}
					}else{
						this.$confirm('请先完善个人信息！', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning',
						}).then(()=>{
							this.isshow = 1
						})
					}
				}else{
					this.$confirm('请先登录再报名！', '提示', {
						confirmButtonText: '确定',
						type: 'warning'
					}).then(() => {
						this.login = 1
					})
				}
			},
			Shutdown(){
				var competition_info = JSON.parse(localStorage.getItem('competition_info'))
				console.log(this.UserInfo.UserName)
				if(competition_info){
					if(this.UserInfo.UserName){
						if(competition_info.RegistType == 1||competition_info.RegistType == 2){
							this.$confirm('你已报名，请前往个人中心进行线上学习或答题！', '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {

							})
						}else{
							this.down = 1
						}
					}else{
						this.$confirm('请先完善个人信息！', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(()=>{
							this.isshow = 1
						})
					}
				}else{
					this.$confirm('请先登录再报名！', '提示', {
						confirmButtonText: '确定',
						type: 'warning'
					}).then(() => {
						this.login = 1
					})
				}

			},

		},
		components: {teamSign,vLogin,IndividualEditor}
	}
</script>

<style scoped="scoped" lang="scss">
	.introduce {
		width: 100%;
		overflow: hidden;

		.unitbox {
			color: #ff0;

			.unitbox-inner {
				width: 900px;
				padding: 30px 0;
				margin: 0 auto;
				.units{
					color: #666;margin: 20px 0 30px 0;
					span{margin-left: 50px;font-size: 16px}
				}
				.unit_title{
					color: #e6403e;
					padding: 0 60px;
					background: url('../assets/翅膀_34.png') no-repeat center center;
					background-size: 100% 100%;
					text-align: center;
					background-position-x: -5px;
				}
			}
		}

		.introduce-top {
			width: 100%;
			height: 350px;
			background: url('../assets/5.jpg') no-repeat;
			background-size: cover;
			background-position-y: -90px
		}

		.describe {
			width: 900px;
			margin: auto;
			position: absolute;
			left: 0;
			right: 0;
			top: 300px;
			z-index: 1;
			padding: 40px 30px;
			box-sizing: border-box;
			border-radius: 10px;
			color: #333;
			background: url('../assets/wen.png') #fff no-repeat center center;
			background-size: cover;

			.mark {
				font-weight: bold;
				border-bottom: 2px solid #333;
				position: relative;
			}

			.mark:after {
				content: '';
				width: 8px;
				height: 8px;
				background: #333;
				border-radius: 50%;
				position: absolute;
				bottom: -4px;
				right: -7px;
			}

			.details {
				padding: 20px 30px;
				font-size: 14px;
				line-height: 28px;
			}

			.button-box {
				text-align: center;

				button {
					padding: 5px 20px;
					color: #ab886b;
					border: 1px solid #ab886b;
					border-radius: 5px;
				}

				.personalbtn {
					background: #ab886b;
					color: #fff;
					margin-right: 20px
				}
			}
		}

		.introduce-review {
			width: 100%;
			background: #edeeef;
			padding-top: 400px;
			box-sizing: border-box;
			overflow: hidden;
			position: relative;
			color: #333;

			h1 {
				text-align: center;
				font-size: 24px;
				font-weight: bold;
			}

			.review-box {
				margin: 50px auto;
				width: 1000px;
				display: flex;
				justify-content: space-between;
				flex-wrap: wrap;

				// flex-direction: column;
				.judges {
					width: 20%;
					text-align: center;
					margin-bottom: 20px;

					.imgbox {
						width: 120px;
						height: 120px;
						margin: 0 auto;
						overflow: hidden;
						border-radius: 50%;
					}

					img {
						width: 120px;
					}

					.name {
						margin: 10px 0;
					}

					.title {
						font-size: 10px;
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/introduce.vue